// extracted by mini-css-extract-plugin
export default {"wrapper":"form_wrapper__-9di7","form":"form_form__6zzu6","stepper":"form_stepper__OhyY5","controls":"form_controls__bWf03","opacity-transition":"form_opacity-transition__AL3jC"};